import { Component, OnInit } from '@angular/core';
import { DevExtremeModule } from 'devextreme-angular';
import * as _ from 'lodash';
import { CdrUnitOfWork } from 'src/app/core/core.module';
import { ZoneZipCode } from 'src/app/core/model/zone-zip-code';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';

@Component({
    selector: 'app-zone-zip-dialog',
    templateUrl: './zone-zip-dialog.component.html',
    styleUrls: ['./zone-zip-dialog.component.scss'],
    standalone: true,
    imports: [DevExtremeModule]
})
export class ZoneZipDialogComponent extends BaseDialogComponent<any> implements OnInit {
    zip: ZoneZipCode;
    zones = ["1", "2", "3", "4"];

    constructor(private uow: CdrUnitOfWork) {
        super();
    }

    ngOnInit() {
    }

    save = async () => {
        this.hide({ success: true, value: { zip: this.zip } });
    };

    cancel = async () => {
        this.hide({ success: false });
    };
}
